// react
import React, { useState, createContext, useMemo } from "react";

//components
import Loader from "./Loader";

// tools
import Services from "tools/Services";
import { Role } from "tools/Enums";

// All App is wraped inside this component in order to have a global state called 'role'
// role = 0 -> user not loged, can't access any page, would be redirected to login all the time
// role = 1 -> normal user loged, doesn't have some privileges
// role = 2 -> admin, full permisions like edit, delete, settings, etc

// state and setState
export const MyContext = createContext({
	role: Role.Unauthorized,
	setRole: () => {},
});

export default function RoleContext(props) {
	const [loading, setLoading] = useState(true);
	const [role, setRole] = useState(Role.Unauthorized);
	// Memoization -> speed up the app by caching the state
	const value = useMemo(() => ({ role, setRole }), [role]);

	// when app refresh or starts we check if the token is valid to redirect home automatically
	const checkToken = async () => {
		const token = { token: "", refreshToken: Services.getToken(), Role: "" };

		// POST
		let res = await Services.post("/Login/CheckToken", token);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			setLoading(false);
			return;
		}

		// SUCCESS
		if (res.data.roles === "Admin") {
			setRole(Role.Admin);
		} else {
			setRole(Role.User);
		}
		setLoading(false);
	};

	checkToken();

	return (
		<>
			{loading && <Loader />}
			{!loading && <MyContext.Provider value={value}>{props.children}</MyContext.Provider>}
		</>
	);
}
